<template>
    <div class="chatbot-edit-answer-popup">

        <!-- EDIT ANSWER POPUP -->
        <v-layout row justify-center>
            <v-dialog v-model="getMustShowEditAnswerPopup"
                      persistent
                      max-width="600"
                      content-class="dialog-chatbot-edit-question-answer"
                      transition="dialog-bottom-transition"

            >
                <v-card class="no-padding">
                    <v-card-text class="text-center no-padding">

                        <div >
                            <div class="edit-answer-popup-header">
                                <h1>
                                    <span class="close-edit-answer-title">{{text("api.chatbot.conversationMsg.editAnswer")}}</span>
                                </h1>
                                <div id="iconCloseEditAnswerPopup" class="font-weight-light close-edit-answer-icon">
                                    <close-icon v-if="getCrtEditingQuestionData"
                                                @click.native="closeEditAnswerPopup"
                                                :svg-fill-class="'svg-secondary-color'"
                                               />
                                </div>


                            </div>

                            <!-- BEGIN Edit generic question -->
                            <div v-if="getCrtEditingQuestionData && getCrtEditingQuestionData.type !== getAssessmentStatuses.NO_OTHER_SYMPTOMS"
                                 class="edit-answer-popup-content">
                                <div class="edit-answers-position">
                                    <message-received
                                        v-if="getCrtEditingQuestionData.text.length > 0"
                                        :question-data="getCrtEditingQuestionData"
                                        :msgText="getCrtEditingQuestionData.text"
                                        :is-edit="true"
                                    >
                                    </message-received>

                                    <div class="chatbot-answer-list-edit" style="padding-bottom: 8px;">
                                        <answer-list-editing-question @onAnswerSubmitted="handleAnswerSubmitted"></answer-list-editing-question>
                                    </div>
                                </div>
                            </div>
                            <!-- END Edit generic question -->

                            <!-- BEGIN Edit No Other Symptoms -->
                            <div v-else-if="getCrtEditingQuestionData && getCrtEditingQuestionData.type === getAssessmentStatuses.NO_OTHER_SYMPTOMS"
                                 class="edit-answer-popup-content edit-answer-popup-content__no-other-symptoms" >
                                <div class="edit-answers-position">
                                    <message-received
                                        v-if="getCrtEditingQuestionData.text.length > 0"
                                        :question-data="getCrtEditingQuestionData"
                                        :msgText="getCrtEditingQuestionData.text"
                                        :is-edit="true"
                                    >
                                    </message-received>

                                    <div class="chatbot-answer-list-edit__no-other-symptom" style="padding-bottom: 8px;">
                                        <answer-list-editing-question @onAnswerSubmitted="handleAnswerSubmitted"></answer-list-editing-question>
                                    </div>
                                </div>
                            </div>
                            <!-- END Edit No Other Symptoms -->

                            <!-- BEGIN Edit Related Symptoms -->
                            <div v-else-if="getRelatedSymptomList"
                                 class="related-symptom-list-related-symptoms-edit related-symptom-list-related-symptoms">
                                <div class="edit-answers-related-symptoms-content">
                                    <message-received
                                        :conversation-message="{
                                            text: text('api.chatbot.conversationMsg.selectRelatedSymptoms'),
                                            status: this.getAssessmentStatuses.RELATED_SYMPTOMS
                                        }"
                                        :msgText="text('api.chatbot.conversationMsg.selectRelatedSymptoms')"
                                        :is-edit="true"
                                        style="padding-left: 0; padding-right: 0"
                                    >
                                    </message-received>

                                    <div class="answer-items">
                                        <div v-for="(relatedSymptom, index) in getRelatedSymptomList"
                                             :key="relatedSymptom.code"
                                             :ref="'answer-item-'+relatedSymptom.code"
                                             :id="'RELATED_S_EDIT_' + relatedSymptom.code"
                                             class="answer-item">

                                            <v-checkbox
                                                :label="relatedSymptom.name"
                                                v-model="relatedSymptom.state"
                                                :true-value="`${getRelatedSymptomStates.HAVE_SYMPTOM}`"
                                                :false-value="`${getRelatedSymptomStates.NONE}`"
                                                @change="handleChangeRelatedSymptom(relatedSymptom)"
                                                :id="'RELATED_S_EDIT_CHECKBOX_' + relatedSymptom.code"
                                                hide-details
                                            ></v-checkbox>

                                        </div>
                                    </div>
                                </div>
                                <v-btn @click="confirmSelectedRelatedSymptoms"
                                       id="btnConfirmEditSelectedRelatedSymptoms"
                                       color="primary"
                                       class="btn confirm-related-symptoms"
                                       block
                                >{{text("api.chatbot.btn.confirm")}}</v-btn>

                            </div>
                            <!-- END Edit Related Symptoms -->

                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import MessageReceived from './MessageReceived';
import AnswerListEditingQuestion from "./answer-list/AnswerListEditingQuestion";
import Vue from "vue";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";

export default {
    name: 'EditAnswerPopup',
    components: {
        CloseIcon,
        MessageReceived,
        AnswerListEditingQuestion
    },

    data() {
        return {
            crtSelectedAnswerCode: null,
            isConfirmRelSymptomsBtnClickDisabled: false, // This will help us to prevent multiple clicks on Confirm button (for Related Symptoms).
            radioButtonPfPlugin: Vue.RadioButtonPf.RadioButtonPfSvg
        }
    },

    computed: {
        ...mapGetters({
            getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
            getAssessmentStatuses: "ChatBotStore/getAssessmentStatuses",
            getConversationMessageTypes: 'ChatBotStore/getConversationMessageTypes',
            getMustShowEditAnswerPopup: 'ChatBotStore/getMustShowEditAnswerPopup',
            getCrtEditingQuestionData: "ChatBotStore/getCrtEditingQuestionData",
            getRelatedSymptomList: 'ChatBotStore/getRelatedSymptomList',
            getRelatedSymptomStates: 'ChatBotStore/getRelatedSymptomStates',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
        }),

        selectedRelatedSymptoms() {
            let selectedSymptomsArr = this.getRelatedSymptomList.reduce((selectedRelatedSymptoms, crtSymptom) => {
                if (crtSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM) {
                    selectedRelatedSymptoms.push(crtSymptom);
                }
                return selectedRelatedSymptoms;
            }, []);

            return selectedSymptomsArr;
        },

        selectedRelatedSymptomNames() {
            let selectedSymptomNamesArr = this.getRelatedSymptomList.reduce((selectedRelatedSymptoms, crtSymptom) => {
                if (crtSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM) {
                    selectedRelatedSymptoms.push(crtSymptom.name);
                }
                return selectedRelatedSymptoms;
            }, []);

            return selectedSymptomNamesArr;
        }
    },

    watch: {
        getMustShowEditAnswerPopup(newVal, oldVal) {

            if (oldVal === false && newVal === true) {// OPEN POPUP.

                // ----- Set popup height (fix for iPad/Safari) and answer list scrollable area height -----
                this.setHeights();

                // ----- Scroll to previously selected answer -----
                setTimeout(() => {

                    let answerItemsElem = document.querySelector('.dialog-chatbot-edit-question-answer .answer-items');

                    // Generic question
                    let providedAnswerElem_genericQuestion = document.querySelector('.dialog-chatbot-edit-question-answer .answer-item.is-already-provided-answer');
                    if (providedAnswerElem_genericQuestion && answerItemsElem) {
                        let scrollTopToBeSet = providedAnswerElem_genericQuestion.offsetTop
                            - answerItemsElem.offsetTop
                            - (answerItemsElem.offsetHeight
                                - providedAnswerElem_genericQuestion.offsetHeight);
                        this.UtilitiesPlugin.smoothScrollElementTo(scrollTopToBeSet, answerItemsElem);
                    }

                    // Related symptoms
                    let providedAnswerElem_relatedSymptoms = document.querySelector('.dialog-chatbot-edit-question-answer .related-symptom-list-related-symptoms-edit .answer-item .input-group--active');
                    if (providedAnswerElem_relatedSymptoms) {
                        let scrollTopToBeSet = providedAnswerElem_relatedSymptoms.offsetTop
                            - answerItemsElem.offsetTop
                            - (answerItemsElem.offsetHeight
                                - providedAnswerElem_relatedSymptoms.offsetHeight);
                        this.UtilitiesPlugin.smoothScrollElementTo(scrollTopToBeSet, answerItemsElem);
                    }
                    let that = this;

                    let relatedSymptomsList = document.getElementsByClassName('edit-answers-related-symptoms-content')
                    if (relatedSymptomsList.length > 0) {
                        let relatedSymptoms = relatedSymptomsList[0].getElementsByClassName('answer-item');

                        for (let i = 0; i < relatedSymptoms.length; i++) {
                            let selectedRelatedSymptom = relatedSymptoms[i].getElementsByClassName('icon--checkbox');
                            if (selectedRelatedSymptom.length > 0) {

                                for (let j = 0; j < selectedRelatedSymptom.length; j++) {
                                    selectedRelatedSymptom[j].innerHTML = that.radioButtonPfPlugin()
                                }

                            }
                        }
                    }

                }, 600);
            }
            else { // CLOSE POPUP.

                setTimeout(() => {
                    let answerItemsElem = document.querySelector('.dialog-chatbot-edit-question-answer .answer-items');

                    if (answerItemsElem) {
                        // Reset scroll and answer list height
                        answerItemsElem.scrollTop = 0;
                        answerItemsElem.style.height = "";
                    }
                }, 300);
            }
        }
    },


    mounted() {
        window.addEventListener('resize', this.UtilitiesPlugin.debounce(this.setHeights, 200));

    },

    beforeDestroy() {
        window.removeEventListener('resize', this.UtilitiesPlugin.debounce(this.setHeights, 200));
    },

    methods: {

        // ================================================
        // Generic questions
        // ================================================

        handleAnswerSubmitted(response) {

            this.$store.dispatch("ChatBotStore/setReloadedAssessmentData", response).then(() => {
                this.$store.commit("ChatBotStore/resetCrtEditingQuestionData");
            });
            this.PfChatbotPlugin.showScroll();
            // @TODO Shouldn't we use "closeEditAnswerPopup()" function?
            this.$store.commit("ChatBotStore/setMustShowEditAnswerPopup", false); // Hide Edit Answer Popup.
            this.isConfirmRelSymptomsBtnClickDisabled = false;

        },

        // ================================================
        // Related symptoms
        // ================================================

        handleChangeRelatedSymptom(changedRelatedSymptom){

            if (changedRelatedSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM){
                this.$store.dispatch("ChatBotStore/selectRelatedSymptom", {
                    "symptom": changedRelatedSymptom,
                    "edit": true
                });
            }
            else {
                this.$store.dispatch("ChatBotStore/deselectRelatedSymptom", {
                    "symptom": changedRelatedSymptom,
                    "edit": true
                });
            }

            let that = this;
            setTimeout(function() {
                let relatedSymptomsList = document.getElementsByClassName('edit-answers-related-symptoms-content')
                let relatedSymptoms = relatedSymptomsList[0].getElementsByClassName('answer-item');
                for (let i = 0; i < relatedSymptoms.length; i++) {
                    let selectedRelatedSymptom = relatedSymptoms[i].getElementsByClassName('icon--checkbox');
                    if (selectedRelatedSymptom.length > 0) {

                        for (let j = 0; j < selectedRelatedSymptom.length; j++) {

                            selectedRelatedSymptom[j].innerHTML = that.radioButtonPfPlugin()
                        }

                    }
                }
            }, 300)

        },

        confirmSelectedRelatedSymptoms () {

            if (this.isConfirmRelSymptomsBtnClickDisabled === true) {
                return; // Clicks on Confirm button are disabled, so do nothing else.
            }
            else {
                this.isConfirmRelSymptomsBtnClickDisabled = true; // Clicks on Confirm button were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
            }

            this.$store.dispatch("ChatBotStore/submitConfirmRelatedSymptoms", {
                "edit": true
            }).then((response) => {

                this.isConfirmRelSymptomsBtnClickDisabled = false;
                this.$emit("onClickedAnswer");

                let promise = this.$store.dispatch("ChatBotStore/setReloadedAssessmentData", response);

                let that = this;
                promise.then(function() {

                    that.PfChatbotPlugin.setVerticalSpacing();

                    that.PfChatbotPlugin.refreshIsMoreContentAvailable();

                    // Clear related symptoms.
                    that.$store.commit("ChatBotStore/clearRelatedSymptomList");
                });

                this.PfChatbotPlugin.showScroll();
                this.$store.commit("ChatBotStore/setMustShowEditAnswerPopup", false);

            });
        },


        // ================================================
        // No Other Symptoms
        // ================================================

        // ================================================
        // Popup utils.
        // ================================================

        closeEditAnswerPopup() {
            this.PfChatbotPlugin.showScroll();
            this.$store.commit("ChatBotStore/setMustShowEditAnswerPopup", false);
            this.isConfirmRelSymptomsBtnClickDisabled = false;
        },


        /**
         * Compute and set popup height (fix for iPad/Safari) and answer list scrollable area height.
         */
        setHeights() {
            this.setPopupHeight().then((newPopupHeight) => {
                this.setAnswerListAreaHeight_RelatedSymptoms(newPopupHeight);
            });
        },


        /**
         * Compute and set Edit Answer Popup height.
         * @return {Promise}
         */
        setPopupHeight() {

            let promise = new Promise((resolve, reject) => {

                let editAnswerPopupElem = document.querySelector(".dialog-chatbot-edit-question-answer");
                let newPopupHeight;

                if (window.innerWidth >= 600) {
                    // Medium and big screens.
                    let pageHeaderHeight = document.querySelector(".chatbot-page-header nav.header-pathfinder");
                    if(pageHeaderHeight) {
                        let pageHeaderOffsetHeight = pageHeaderHeight.offsetHeight;
                        newPopupHeight = window.innerHeight - pageHeaderOffsetHeight;
                    }
                }
                else {
                    // Small screens.
                    newPopupHeight = window.innerHeight;
                }

                if(editAnswerPopupElem) {
                    editAnswerPopupElem.style.height = newPopupHeight + "px";
                }
                resolve(newPopupHeight);
            });

            return promise;
        },

        /**
         * Compute and set Answer List scrollable area height.
         * @param {Number} popupHeight - The height of Edit Answer popup.
         */
        setAnswerListAreaHeight_RelatedSymptoms(popupHeight) {

            let popupHeader = document.querySelector(".dialog-chatbot-edit-question-answer .edit-answer-popup-header");
            let popupContentWrapperElem = document.querySelector(".dialog-chatbot-edit-question-answer .related-symptom-list-related-symptoms-edit");
            let question = document.querySelector(".dialog-chatbot-edit-question-answer .edit-answers-related-symptoms-content .received-message-item");
            let answerList = document.querySelector(".dialog-chatbot-edit-question-answer .edit-answers-related-symptoms-content .answer-items");
            let confirmBtn = document.querySelector(".dialog-chatbot-edit-question-answer .related-symptom-list-related-symptoms-edit .confirm-related-symptoms");

            if (popupHeader && popupContentWrapperElem && question && confirmBtn && answerList) {

                let popupContentWrapperElemPaddingTop = parseInt(window.getComputedStyle(popupContentWrapperElem).getPropertyValue('padding-top'));
                let popupContentWrapperElemPaddingBottom = parseInt(window.getComputedStyle(popupContentWrapperElem).getPropertyValue('padding-bottom'));
                let confirmBtnMarginTop = parseInt(window.getComputedStyle(confirmBtn).getPropertyValue('margin-top'));

                let newHeightToBeSet = (popupHeight
                        - popupHeader.offsetHeight
                        - popupContentWrapperElemPaddingTop
                        - question.offsetHeight
                        - confirmBtnMarginTop
                        - confirmBtn.offsetHeight
                        - popupContentWrapperElemPaddingBottom);

                answerList.style.height = newHeightToBeSet + "px";
            }
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/EditAnswerPopup.vue